export const formatDate = (
  isoDate: string,
  options?: {
    [key: string]: string;
  }
) =>
  new Intl.DateTimeFormat('ru-RU', options).format(
    new Date(isoDate)
  );
